import Vue from 'vue'
import App from './App.vue'
import 'normalize.css'
import '../utils/rem'
import axios from 'axios'
import jsencrypt from 'jsencrypt'
import fastClick from 'fastclick'
import mock from 'mockjs';
fastClick.attach(document.body)

Vue.config.productionTip = true
// 把axios挂载到vue的原型上可以全局使用
Vue.prototype.$axios = axios
// jsencrypt加密方法挂载到全局使用
Vue.prototype.$jsEncrypt = new jsencrypt()
//把mock挂载到全局使用
Vue.prototype.$Mock=mock;
new Vue({
  render: h => h(App),
}).$mount('#app')